import { APP_BRAND, HAUFFE_LOGO, HAUFFE_SYMBOL } from "../lib/brand";

type HeadingLevel = "h1";

interface HauffeLogoProps {
  language?: "de" | "en";
  compact?: boolean;
}

export function HauffeLogo({ language = "de", compact = false }: HauffeLogoProps) {
  return (
    <span className={compact ? "app-brand app-brand-compact" : "app-brand"}>
      <img
        src={HAUFFE_LOGO.src}
        srcSet={HAUFFE_LOGO.srcSet}
        sizes={HAUFFE_LOGO.sizes}
        width={HAUFFE_LOGO.width}
        height={HAUFFE_LOGO.height}
        decoding="async"
        loading="eager"
        alt={language === "en" ? HAUFFE_LOGO.altEn : HAUFFE_LOGO.altDe}
      />
      {!compact ? (
        <span className="app-brand-copy">
          <strong>{APP_BRAND.product}</strong>
          <small>{APP_BRAND.workspace}</small>
          <small>{APP_BRAND.subline}</small>
        </span>
      ) : null}
    </span>
  );
}

interface HauffeLoaderProps {
  label: string;
  language?: "de" | "en";
}

export function HauffeLoader({ label, language = "de" }: HauffeLoaderProps) {
  return (
    <span className="hauffe-loader" role="status" aria-live="polite">
      <img
        src={HAUFFE_SYMBOL.src}
        width={HAUFFE_SYMBOL.width}
        height={HAUFFE_SYMBOL.height}
        alt={language === "en" ? HAUFFE_SYMBOL.altEn : HAUFFE_SYMBOL.altDe}
        decoding="async"
      />
      <span>{label}</span>
    </span>
  );
}

interface BrandHeadingProps {
  level?: HeadingLevel;
  children: string;
  className?: string;
  language?: "de" | "en";
}

export function BrandHeading({ level = "h1", children, className, language = "de" }: BrandHeadingProps) {
  const Heading = level;
  const classes = ["brand-heading", `brand-heading-${level}`, className].filter(Boolean).join(" ");

  return (
    <Heading className={classes}>
      <img
        src={HAUFFE_SYMBOL.src}
        width={HAUFFE_SYMBOL.width}
        height={HAUFFE_SYMBOL.height}
        alt=""
        aria-hidden="true"
        decoding="async"
        loading="eager"
      />
      <span>{children}</span>
      <span className="sr-only">{language === "en" ? HAUFFE_SYMBOL.altEn : HAUFFE_SYMBOL.altDe}</span>
    </Heading>
  );
}
